import { render, staticRenderFns } from "./InvoiceItemDialog.vue?vue&type=template&id=5704dc42&"
import script from "./InvoiceItemDialog.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItemDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports